import { Button, Inline, useModeContext } from 'canoe';
import React from 'react';

export type TextButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'css'>;

export const TextButton: React.FC<TextButtonProps> = (props: TextButtonProps) => {
  const { mode } = useModeContext();

  return (
    <Inline justify="flex-end" mt="xxs" space="none">
      <Button
        appearance="text"
        variant={mode === 'Dark' ? 'white' : 'contrast'}
        size="xsmall"
        {...props}
      >
        {props.children}
      </Button>
    </Inline>
  );
};
